import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import type { TreeNode } from 'primeng/api';
import { TreeSelectModule } from 'primeng/treeselect';
import { buildOrgUnitTreeOptions, OrgUnitTreeSource } from '@shared/utils/org-unit-tree.util';

@Component({
  selector: 'app-org-unit-tree-select',
  standalone: true,
  imports: [CommonModule, FormsModule, TreeSelectModule],
  templateUrl: './org-unit-tree-select.component.html',
  styleUrl: './org-unit-tree-select.component.scss',
})
export class OrgUnitTreeSelectComponent implements OnChanges {
  @Input() units: OrgUnitTreeSource[] = [];
  @Input() value = '';
  @Input() label = '';
  @Input() placeholder = '';
  @Input() searchPlaceholder = '';
  @Input() overlayPanelClass = 'org-unit-tree-select-panel';
  @Input() overlayRootClass = '';
  @Input() disabled = false;
  @Input() leafOnly = false;
  @Output() readonly valueChange = new EventEmitter<string>();

  treeOptions: TreeNode[] = [];
  selectedNode: TreeNode | null = null;

  ngOnChanges(): void {
    this.treeOptions = buildOrgUnitTreeOptions(this.units);
    if (this.leafOnly) {
      this.markBranchesAsNotSelectable(this.treeOptions);
    }
    this.selectedNode = this.findNode(this.treeOptions, this.value);
  }

  onSelectionChange(node: TreeNode | null): void {
    this.selectedNode = node;
    this.valueChange.emit(node?.key ? String(node.key) : '');
  }

  private markBranchesAsNotSelectable(nodes: TreeNode[]): void {
    for (const node of nodes) {
      const children = node.children || [];
      node.selectable = children.length === 0;
      this.markBranchesAsNotSelectable(children);
    }
  }

  private findNode(nodes: TreeNode[], key: string): TreeNode | null {
    if (!key) return null;
    for (const node of nodes) {
      if (String(node.key) === key) return node;
      const match = this.findNode(node.children || [], key);
      if (match) return match;
    }
    return null;
  }
}
